module.exports = __webpack_public_path__ + "img/Samurai.1c3188ec.svg";